import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  downPayment?: number;
  purchasePrice?: number;
  propertyValue?: number;
  purchasePriceActive?: boolean;
  removeDownPayment?: boolean;
}

export const calculateDownPaymentPercentage = (
  form: FormInstance,
  loanIndex: string | number,
  {
    downPayment,
    purchasePrice,
    propertyValue,
    purchasePriceActive,
    removeDownPayment
  }: FieldValues = {}
) => {
  const downPaymentValue = downPayment ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'downPayment', 'value'])) || 0);

  const purchasePriceValue = purchasePrice ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'purchasePrice', 'value'])) || 0);

  const propertyValueValue = propertyValue ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'propertyValue'])) || 0);

  const removeDownPaymentValue = removeDownPayment ??
    form.getFieldValue(['loans', loanIndex, 'externalLoan', 'removeDownPayment']);

  const purchasePriceActiveValue = purchasePriceActive ?? form.getFieldValue(['tableView', 'purchasePrice', 'active']);

  if (removeDownPaymentValue) return 0;

  const price = purchasePriceActiveValue ? purchasePriceValue : propertyValueValue;

  return parseFloat(formatAmount((downPaymentValue / price) * 100));
}
